module.exports = {
  emptyMessage: 'กรุณากรอกชื่อของคุณ',
  defaultMessage: 'ชื่อไม่ถูกต้อง',
};
